import React from 'react';
import ReactLoading from 'react-loading';
import { Modal } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

const LoadingComponent = ({ hidden }) => {
    return <Modal animation={false} show={hidden}>
        <Modal.Body>
            <ReactLoading type="cubes" color="#000000" />
            <FormattedMessage id="commonMessages.loading" />
        </Modal.Body>
    </Modal>
};

export default LoadingComponent;
